import { getRoleList } from 'src/local-logic/tip-match/my-award/role-list';

export const selectRoleMixin = {
  data() {
    return {
      showSelectRoleDialog: false,
      roleList: [],
      selectRoleIndex: -1,
    };
  },
  computed: {
    curGameInfo() {
      const { roleList, selectRoleIndex } = this;
      let findItem = {};
      if (selectRoleIndex !== -1) {
        findItem = roleList[selectRoleIndex];
      } else {
        const gameInfo = this.$store.state?.user?.gameInfo || {};
        findItem = roleList.find(item => item?.subarea === gameInfo.subarea,
        // && item?.rolename === gameInfo.rolename
        // && item?.device === gameInfo.device
        // && item?.area === gameInfo.area
        );
        if (!findItem) {
          findItem = roleList[0] || {};
        }
      }
      const result = {
        ...(findItem || {}),
        ...(findItem?.roleBaseInfo || {}),
      };
      console.log('[curGameInfo]: ', result, roleList);
      return result;
    },
    curRoleName() {
      const { gzoneName = '', rolename = '', extra = ''  } = this.curGameInfo || {};
      return extra || `${rolename}-${gzoneName.split('-')[0]}`;
    },
  },
  mounted() {
  },
  methods: {
    fetchRoleInfo() {
      return new Promise((resolve, reject) => {
        getRoleList({}).then((res = {}) => {
          this.roleList = [
            ...(res.rolelist || []),
          ];
          console.log('[roleList]', this.roleList);
          resolve();
        })
          .catch((err) => {
            reject(err);
          });
      });
    },
    onRoleChange(index) {
      console.log('[onRoleChange] index', index);
      this.selectRoleIndex = index;
      setTimeout(() => {
        this.showSelectRoleDialog = false;
      }, 300);
    },
  },
};
